import { render, staticRenderFns } from "./accountSet.vue?vue&type=template&id=703c5fc8&scoped=true"
import script from "./accountSet.vue?vue&type=script&lang=js"
export * from "./accountSet.vue?vue&type=script&lang=js"
import style0 from "./accountSet.vue?vue&type=style&index=0&id=703c5fc8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703c5fc8",
  null
  
)

export default component.exports